/**
 * Ensures URLs are compatible with CloudFront + S3 origin by adding trailing slash before query parameters
 * CloudFront drops query parameters unless the URL ends with a trailing slash before the query string
 * Also ensures all URLs end with a trailing slash for proper CloudFront routing
 * @param url - The URL to fix
 * @returns The URL with proper trailing slash for CloudFront compatibility
 */
export const fixUrlForCloudFront = (url: string): string => {
  // If URL has query parameters and doesn't end with a trailing slash before the query string
  if (url.includes('?') && !url.includes('/?')) {
    // Add trailing slash before the query string
    return url.replace('?', '/?');
  }

  // Ensure URL ends with a trailing slash for CloudFront compatibility
  if (!url.endsWith('/')) {
    return `${url}/`;
  }

  return url;
};
